import React from 'react'
import styled, { css } from 'styled-components'
import topVideoSrc from '../data/videos/zuri-hybrid-vtol-technology-overview-animation-transition-propulsion.mp4'
import Video from './Video'
import Section from './Section'
import { up } from '../lib/styles'

const Wrapper = styled(Section.FullHeight)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  /* height: auto; */
  overflow: hidden;

  video {
    width: 160%;
    ${up('mobile')} {
      width: 100%;
    }
  }
`

const TechnologyTopVideo = () => (
  <Wrapper>
    <Video
      src={topVideoSrc}
      centered
      muted
      autoPlay
      loop
      aria-label="Animated video overview of Zuri Hybrid VTOL technology, highlighting distributed propulsion, lift-to-cruise transition, aerodynamic design, and mobility use cases."
    />
  </Wrapper>
)

export default TechnologyTopVideo
